import React, { ReactNode, useReducer } from "react";
import { ConfigurationStore } from "stores";

import type { TFilter } from "../types";

import FilterReducer from "./FilterStoreReducer";
import { getAllowedSorter, emptyFilterStore } from "./helper";

type TFilterProvider = {
  config: { type: string };
  children: ReactNode;
};

export const FilterStore = React.createContext<{
  state: TFilter;
  dispatch: React.Dispatch<any>;
}>({
  state: emptyFilterStore,
  dispatch: () => null,
});

const FilterProvider = ({
  config = { type: "prod" },
  children,
}: TFilterProvider) => {
  const [state, dispatch] = useReducer(FilterReducer, emptyFilterStore);
  const configuration = React.useContext(ConfigurationStore);

  React.useEffect(() => {
    let newSorter;
    if (configuration.defaultSorter) {
      newSorter = getAllowedSorter(configuration.defaultSorter);
      dispatch({ type: "CHANGE_ORDER", payload: newSorter });
    }
  }, [configuration]);

  return (
    <FilterStore.Provider value={{ state, dispatch }}>
      {children}
    </FilterStore.Provider>
  );
};

export default FilterProvider;
